import { layoutColors } from '~/components/layout/componentStyles/colors'
import { sharedComponentColors } from '~/components/shared/componentStyles/_colors'
import { contactsColors } from '~/pages/Contacts/componentStyles/_colors'
import { faxColors } from '~/pages/Fax/componentStyles/_colors'
import { homeColors } from '~/pages/Home/componentStyles/_colors'
import { siteNavigationColors } from '~/pages/Home/SiteNavigation/componentStyles/_colors'
import { topNavColors } from '~/pages/Home/TopNav/componentStyles/_colors'
import { loginColors } from '~/pages/Login/componentStyles/_colors'
import { messagingColors } from '~/pages/Messaging/componentStyles/_colors'
import { settingsColors } from '~/pages/Settings/componentStyles/_colors'
import { voicemailColors } from '~/pages/Voicemail/componentStyles/_colors'
import { phoneColors as newPhoneColors } from '~/pages/WebPhone/componentStyles/_colors'
import { defaultColors } from '~/themes/colors/defaultColors'
import { bannerColors as __needsMigration__bannerColors } from '~/themes/colors/sections/banner/bannerColors'
import { faxColors as __needsMigration__faxColors } from '~/themes/colors/sections/fax/faxColors'
import { loginColors as __needsMigration__loginColors } from '~/themes/colors/sections/login/loginColors'
import { sharedColors } from '~/themes/colors/sections/shared/sharedColors'
import { getDotWalkedObjectMap } from '~/utils/objectUtils'

import { ThemeColors } from '.'
import { callsColors } from './sections/calls/callsColors'
import { settingsColors as __needsMigration__settingsColors } from './sections/settings/settingsColors'
import { voicemailColors as __needsMigration__voicemailColors } from './sections/voicemail/voicemailColors'

export const themeColorSections = {
  defaults: defaultColors,
  shared: sharedColors,
  login: __needsMigration__loginColors,
  banner: __needsMigration__bannerColors,
  calls: callsColors,
  fax: {
    ...__needsMigration__faxColors,
  },
  settings: __needsMigration__settingsColors,
  voicemail: __needsMigration__voicemailColors,
  ...sharedComponentColors,
  ...homeColors,
  ...siteNavigationColors,
  ...loginColors,
  ...newPhoneColors,
  ...faxColors,
  ...contactsColors,
  ...layoutColors,
  ...messagingColors,
  ...voicemailColors,
  ...settingsColors,
  ...topNavColors,
}

export type ThemeColorSections = typeof themeColorSections

export type MappedThemeColorSectionKeys = TypeSwapped<
  typeof themeColorSections,
  ThemeColors,
  string
>
export const themeColorSectionKeys = getDotWalkedObjectMap(
  themeColorSections,
  1,
) as MappedThemeColorSectionKeys

export const asChakraVariable = (themeColorSectionKey: string) => {
  const formatted = themeColorSectionKey.replace(/\./g, '-')
  return `var(--chakra-colors-${formatted})`
}
